import { DefaultClass } from "./DefaultClass";
import { utils } from "../../../../../shop/frontend/web/js/utils";

/**
 *  Класс для страницы услуг
 * @extends DefaultClass
 */
export class Service extends DefaultClass {
	constructor() {
		super();
		this.$service = $(".service");
		this.$serviceId = this.$service.data("id");
		this.$serviceButton = $(".js-service-button");
		this.$bottom = $("#js-bottom");
		this.$serviceBuy = $("#js-service-button");
		this.$serviceSum = $("#js-sum");
		this.$serviceInputs = $(".js-service-count");
		this.$ticketsItems = $("#js-tickets-items");
		this.$bottomClear = $("#js-bottom-clear");
		this.$bottomCount = $("#js-bottom-count");
		this.$bottomWord = $("#js-bottom-word");
		this.$bottomPull = $("#js-bottom-pull");
		this.template = $("#js-ticket-template")[0];
		this.$count = $(".js-count");
	}

	init() {
		this.fetchCart();
		this.addActionToCount();
		this.addActionToRemove();

		if (!this.isDesktop.matches) {
			this.getLanguages();
			this.addActionToPull();
			this.addActionToClear();
		}

		this.addActionToBuy();
	}

	fetchCart() {
		this.getCartCount().then(res => {
			if (res.length) {
				$.each(res, (i, order) => {
					$.each(order.carts, (index, cart) => {
						const serviceId = cart.service_id;
						if (serviceId) {
							const service = $(`.service[data-id="${serviceId}"]`);
							service.data("max", Number(service.data("max")) - 1);
						}
					});
				});
			}
		});
	}

	addActionToCount() {
		let sum = Number(this.$serviceSum.text());

		this.$serviceButton.on("click", e => {
			this.maxTickets = Number(this.$service.data("max"));
			const $element = $(e.currentTarget);
			const $count = $element.parents(".service__count");
			const $block = $element.parents(".service__block");
			const id = $block.data("id");
			const price = Number($block.find(".js-service-price").text());
			const name = $block.find(".js-service-name").text();
			const $input = $count.find(".js-service-count");

			let count = Number(this.$bottomCount.text());
			let value = Number($input.val());
			if ($element.hasClass("js-service-minus")) {
				value -= 1;
				count -= 1;
				if (value <= 0) {
					value = 0;
					$element.attr("disabled", "true");
					if ($element.data("is-first")) {
						sum -= price;
						$element.data("is-first", "false");
					}
				} else {
					sum -= price;
				}

				if (count <= 0) {
					count = 0;
				}
				this.removeTicket(price);
				$element.parent().find(".js-service-plus").removeAttr("disabled");
			}

			if ($element.hasClass("js-service-plus")) {
				if (!this.checkMax()) return false;
				value += 1;

				if (value >= 99) {
					value = 99;
					$element.attr("disabled", "true");
				} else {
					sum = sum + price;
					count += 1;
				}
				$element
					.parent()
					.find(".js-service-minus")
					.removeAttr("disabled")
					.data("is-first", "true");
				this.insertDataToTicket(name, price, id);
			}

			$input.val(value);
			$input.data("prev", value);

			this.$serviceSum.text(sum);
			if (!this.isDesktop.matches) {
				this.$bottomCount.text(count);
				this.$bottomWord.text(
					utils.wordEnding(count, [
						this.getWord("event", "ticket"),
						this.getWord("event", "tickets"),
						this.getWord("event", "tickets "),
					])
				);
			}
			this.checkPrice();
		});

		this.$serviceInputs.on("input", e => {
			const $element = $(e.currentTarget);
			const $block = $element.parents(".service__block");
			const price = Number($block.find(".js-service-price").text());
			const name = $block.find(".js-service-name").text();
			const id = $block.data("id");
			const minus = $block.find(".js-service-minus");
			const plus = $block.find(".js-service-plus");
			this.maxTickets = Number(this.$service.data("max"));

			if ($element.val() <= 0) {
				$element.val(0);
				minus.attr("disabled", "true");
			}
			if ($element.val() >= 99) {
				$element.val(99);
				plus.attr("disabled", "true");
			} else {
				plus.removeAttr("disabled");
			}

			let value = $element.val();
			let prevValue = $element.data("prev");
			value = value.replace(/^0+/, ""); //убирает ведущий ноль
			$element.val(value);
			if (prevValue < value) {
				for (let i = 0; i < value - prevValue; i++) {
					this.insertDataToTicket(name, price, id);
					sum = sum + price;
				}
				minus.removeAttr("disabled").data("is-first", "true");
			} else {
				for (let i = 0; i < prevValue - value; i++) {
					this.removeTicket(price);
					sum -= price;
				}
			}
			if (!this.checkMax()) {
				e.preventDefault();
				$element.val($element.data("prev"));
				return false;
			}
			$element.data("prev", value);
			this.$serviceSum.text(sum);
			this.checkPrice();
		});
	}

	insertDataToTicket(name, price, id) {
		const $fragment = $(document.importNode(this.template.content, true));
		$fragment.find(".js-ticket-price").text(price);
		$fragment.find(".js-ticket-sector").text(name);
		$fragment.find(".js-ticket-place").text("Входной билет");
		$fragment.find(".js-tickets-remove").data("id", id);
		this.$ticketsItems.append($fragment);
	}

	addActionToRemove() {
		$(document).on("click", ".js-tickets-remove", e => {
			const $element = $(e.currentTarget);
			const id = $element.data("id");
			const $block = $(`.service__block[data-id="${id}"]`);
			const price = Number($block.find(".js-service-price").text());
			const $input = $block.find(".js-service-count");

			$input.val(Number($input.val()) - 1);
			$element.parents(".tickets__item").remove();
			this.$serviceSum.text(Number(this.$serviceSum.text()) - price);
			this.checkPrice();
		});
	}

	removeTicket(price) {
		const $ticketItems = $(`.tickets__item`);
		let isBreak = false;
		$.each($ticketItems, (index, item) => {
			const $item = $(item);
			const currentPrice = Number($item.find(".js-ticket-price").text());
			if (currentPrice === price) {
				if (!isBreak) {
					$item.remove();
					isBreak = true;
				}
			}
		});
	}

	checkPrice() {
		const price = Number(this.$serviceSum.text());
		this.$bottom.removeClass("active");

		if (price !== 0) {
			this.$bottom.addClass("active");
		} else {
			$("html").removeClass("overflow-hidden");
		}
	}

	checkMax() {
		const length = $(`.tickets__item`).length;
		if (length >= this.maxTickets) {
			alert("Вы набрали максимальное число билетов");
			return false;
		}
		return true;
	}

	addActionToPull() {
		this.$bottomPull.on("click", () => {
			this.$bottom.toggleClass("open");
			$("html").toggleClass("overflow-hidden");
		});
	}

	addActionToClear() {
		this.$bottomClear.on("click", () => {
			this.$serviceSum.text(0);
			this.$bottom.removeClass("active");
			this.$serviceInputs.val(0);
			this.$bottomCount.text(0);
			this.$bottomWord.text("");
			this.$ticketsItems.html("");
		});
	}

	addActionToBuy() {
		this.$serviceBuy.on("click", e => {
			e.preventDefault();
			const $element = $(e.currentTarget);
			const service_form = $element.closest("form");
			$.post(`/cart/scope-add-no-redirect/${this.$serviceId}`, service_form.serialize())
				.done(() => {
					window.location.replace("/orders/cart");
				})
				.fail(error => {
					alert(error.responseText);
				});
		});
	}
}
